export const NOTICE_ICON_OPTIONS = ['info', 'warning']

export const legacyNoticeLines = (collectionInfo) => {
  const lines = []
  if (!collectionInfo) return lines
  if (collectionInfo.returnLocation || collectionInfo.collectionPoint) {
    lines.push({
      icon: 'info',
      textKey: 'dropBag.legacyNotice',
      textVars: {
        returnLocation: collectionInfo.returnLocation || '',
        collectionPoint: collectionInfo.collectionPoint || ''
      }
    })
  }
  if (collectionInfo.fasterRunnersNote) lines.push({ icon: 'warning', text: collectionInfo.fasterRunnersNote })
  if (collectionInfo.deadlineNote) lines.push({ icon: 'warning', text: collectionInfo.deadlineNote })
  return lines
}